import axios from 'axios.js';

// Resolves the tenant-specific API base URL and persists it - moved out of
// AuthLogin.jsx so the MPIN verification and MPIN reset pages can finish
// login the exact same way after a 2FA challenge succeeds.
export const updateBaseURL = (domain) => {
  let newBaseURL;

  if (domain && domain !== 'undefined' && domain !== '') {
    newBaseURL = process.env.NODE_ENV === 'production'
      ? `https://kitcontact.in/api/${domain}/`
      : `http://localhost:8084/Product/KiTReact/api/${domain}/`;
  } else {
    newBaseURL = process.env.NODE_ENV === 'production'
      ? 'https://kitcontact.in/api'
      : 'http://localhost:8084/Product/KiTReact/api';
  }

  axios.defaults.baseURL = newBaseURL;
  localStorage.setItem('baseURL', newBaseURL);
};

// Stores everything a successful login response gives us and points axios
// at the right tenant API. Called once after a normal (no 2FA) login, and
// again after MPIN verification / MPIN reset completes a 2FA login - both
// paths end up in identical state this way instead of two copies of the
// same block of localStorage.setItem calls drifting apart over time.
export const completeLogin = (data) => {
  localStorage.setItem('id', data.UserID);
  localStorage.setItem('tenant', data.tenant);
  localStorage.setItem('domain', data.domain);
  localStorage.setItem('token', data.token);
  localStorage.setItem('email', data.Email);
  localStorage.setItem('name', data.FullName);
  localStorage.setItem('mobilenumber', data.MobileNumber);
  localStorage.setItem('UserType', data.UserType);
  localStorage.setItem('UserImage', data.Photo);
  localStorage.setItem('AdminUserID', data.AdminUserID);
  localStorage.setItem('Organization', data.Organization);
  localStorage.setItem('Plans', JSON.stringify(data.Plans));
  localStorage.setItem('IsNewContactsAllowed', JSON.stringify(data.Plans && data.Plans.IsNewContactAllowed));

  // updateBaseURL already treats a missing/undefined/empty domain as
  // "no tenant, use the default API root", so this can be called unconditionally.
  updateBaseURL(data.tenant);
};

export default completeLogin;
